/** Session flag: open GDPR acknowledgement modal over the current app page (like other popups). */
export const GDPR_CONSENT_PENDING_KEY = 'gdpr_consent_pending'

/** Window event dispatched by the API interceptor on HTTP 307 (Angular GDPR gate). */
export const GDPR_CONSENT_REQUIRED_EVENT = 'gdpr-consent-required'

/**
 * Silent reject used when the API returns 307 to force service-agreement acknowledgement.
 * Angular completes the request without notifying; callers must not toast this.
 */
export class GdprConsentRequiredError extends Error {
  readonly status = 307
  readonly silent = true

  constructor() {
    super('GDPR_CONSENT_REQUIRED')
    this.name = 'GdprConsentRequiredError'
  }
}

export function isGdprConsentRequiredError(error: unknown): boolean {
  if (error instanceof GdprConsentRequiredError) return true
  if (!error || typeof error !== 'object') return false
  const err = error as {
    name?: string
    status?: number
    silent?: boolean
    message?: string
  }
  if (err.name === 'GdprConsentRequiredError') return true
  if (err.status === 307 && err.silent) return true
  if (err.message === 'GDPR_CONSENT_REQUIRED') return true
  if (err.message === 'Service agreement acknowledgement required.') return true
  return false
}
